import './SplashScreen.css'
import loadingScreenText from '../assets/images/loadingScreenText.png';
import loadingScreenFlower from '../assets/images/loadingScreenFlower.png';
import React from "react"

function SplashScreen(props) {

    return (
        <div className="loadingBlock">
            <img src={loadingScreenText} alt="e-florals" className="loadingScreenText" />
            <div className="fadeImageIn"> 
                <img className="loadingCircleImage" src={loadingScreenFlower} alt="white gerberia flower, with a yellow center" />
            </div>
        </div>
    )
}

export default SplashScreen;